import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useLayoutEffect, useState } from 'react';
import { WebContentState } from '../../store/birdElement/webContentState';
import { setConstraints } from '../../store/birdLayout/BirdLayoutState';
import { selectAccessibilityLabelState, selectBirdWebContentState, } from '../../store/selectors';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
function messageIframe(src, data, ref) {
    var _a;
    if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contentWindow) || !src || src === 'about:blank') {
        return;
    }
    ref.current.contentWindow.postMessage(data, src);
}
export const BirdWebContentBase = function ({ id, actions, iframeSandbox, state, accessibilityLabel, }) {
    const { src, messageDataPost, resultName } = state;
    const iframeRef = useRef(null);
    const [loadedKey, setLoadedKey] = useState();
    const minSize = 100;
    useLayoutEffect(() => {
        actions.setConstraints(id, {
            minWidth: minSize,
            minHeight: minSize,
        });
        function iframeHandle(e) {
            // If there is no message payload, bail.
            // If resultName is undefined or doesn't match the resultName in the message, bail.
            // If the message is not coming from the expected origin, bail.
            if (!e.data ||
                !resultName ||
                resultName !== e.data.resultName ||
                !src ||
                src.indexOf(e.origin) === -1) {
                return;
            }
            // Pass the message on to portable.
            actions.update(id, { messageDataReceive: e.data });
        }
        window.addEventListener('message', iframeHandle);
        return () => {
            window.removeEventListener('message', iframeHandle);
        };
    }, [src, resultName, actions, id]);
    useLayoutEffect(() => {
        if (loadedKey === src) {
            messageIframe(src, messageDataPost, iframeRef);
        }
    }, [loadedKey, src, messageDataPost]);
    return (_jsx("iframe", { style: {
            borderWidth: 0,
            flexGrow: 1,
            flexShrink: 0,
            minWidth: minSize + 'px',
            minHeight: minSize + 'px',
        }, ref: iframeRef, src: src, "aria-label": accessibilityLabel, onLoad: () => setLoadedKey(src), sandbox: iframeSandbox || 'allow-presentation allow-scripts allow-same-origin allow-forms' }));
};
export const BirdWebContent = connect((state, props) => ({
    state: selectBirdWebContentState(state, props.id),
    iframeSandbox: state.transport.iframeSandbox,
    accessibilityLabel: selectAccessibilityLabelState(state, props.id),
}), (dispatch) => ({
    actions: bindActionCreators(Object.assign({ setConstraints }, WebContentState.actions), dispatch),
}))(BirdWebContentBase);
